import { useMutation } from '@tanstack/react-query';
import { publicProposalApi } from '@/api/commercial/public-proposal';

type TrackableAction = 'LINK_VIEWED' | 'DETAILS_VIEWED';

export function useTrackEvent() {
  return useMutation({
    mutationFn: ({ token, action }: { token: string; action: TrackableAction }) =>
      publicProposalApi.track(token, action),
    retry: false,
    meta: { silent: true },
  });
}
